<template>
  <v-card class="rounded-sm" color="primary">
    <v-card-text>
      <v-container>
        <v-overlay v-if="loadingCatalogos" absolute color="primary">
          <v-progress-circular indeterminate size="64" color="secondary"></v-progress-circular>
          <p class="mt-4 text-center">Cargando datos...</p>
        </v-overlay>
        <v-form ref="form" v-model="studiesForm">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="estudio.institucion"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Institución o escuela <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionInicio"
                maxlength="4"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de inicio <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="generacionFin"
                maxlength="4"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :rules="required"
              >
                <template v-slot:label>Año de finalización <span class="red--text">*</span> </template>
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="estatusEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idCatEstatusEstudio"
                :rules="required"
              >
                <template v-slot:label>Estatus de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="tipoEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idCatEstudio"
                :rules="required"
              >
                <template v-slot:label>Tipo de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="comprobanteEstudios"
                item-value="id"
                item-text="title"
                v-model="estudio.fk_idComprobanteEstudio"
                :rules="required"
              >
                <template v-slot:label> Tipo de comprobante de estudios <span class="red--text">*</span> </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea
                no-resize
                rows="4"
                color="secondary"
                background-color="primary"
                label="Observaciones (Opcional)"
                v-model="estudio.observaciones"
                rounded
                filled
                dense
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton :loading="loading" :disabled="!studiesForm || loading" @click="guardarCambios">
        Guardar cambios
      </TextButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TextButton from '@src/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },

  data() {
    return {
      studiesForm: false,
      loading: false,
      loadingCatalogos: false,
      generacionInicio: '',
      generacionFin: '',
      estudio: {
        idEstudioPersonal: null,
        fk_idPersonal: null,
        institucion: '',
        generacion: '',
        observaciones: '',
        fk_idCatEstatusEstudio: null,
        fk_idCatEstudio: null,
        fk_idComprobanteEstudio: null,
      },
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('comprobanteEstudios', {
      comprobanteEstudios: 'getComprobantesEstudios',
    }),
    ...mapGetters('estatusEstudios', {
      estatusEstudios: 'getEstatusEstudios',
    }),
    ...mapGetters('estudio', {
      tipoEstudios: 'getTipoEstudios',
      selectedEstudio: 'getSelectedEstudio',
    }),
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
  },

  methods: {
    ...mapActions('estudio', ['updateEstudiosPersonal', 'fetchEstudiosByPersonal', 'fetchTipoEstudios']),
    ...mapActions('comprobanteEstudios', ['fetchComprobantesEstudios']),
    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),

    async cargarCatalogos() {
      this.loadingCatalogos = true
      try {
        // Ejecutar las peticiones en paralelo solo si no existen los datos
        const promises = []

        if (!this.comprobanteEstudios || this.comprobanteEstudios.length === 0) {
          promises.push(this.fetchComprobantesEstudios())
        }

        if (!this.estatusEstudios || this.estatusEstudios.length === 0) {
          promises.push(this.fetchEstatusEstudios())
        }

        if (!this.tipoEstudios || this.tipoEstudios.length === 0) {
          promises.push(this.fetchTipoEstudios())
        }

        // Esperar a que todas las peticiones terminen en paralelo
        await Promise.all(promises)
      } catch (error) {
        console.error('Error al cargar catálogos:', error)
      } finally {
        this.loadingCatalogos = false
      }
    },

    cargarDatosEstudio() {
      if (this.selectedEstudio) {
        this.estudio = {
          idEstudioPersonal: this.selectedEstudio.idEstudioPersonal,
          fk_idPersonal: this.selectedEstudio.fk_idPersonal,
          institucion: this.selectedEstudio.institucion,
          generacion: this.selectedEstudio.generacion,
          observaciones: this.selectedEstudio.observaciones,
          fk_idCatEstatusEstudio: this.selectedEstudio.fk_idCatEstatusEstudio,
          fk_idCatEstudio: this.selectedEstudio.fk_idCatEstudio,
          fk_idComprobanteEstudio: this.selectedEstudio.fk_idComprobanteEstudio,
        }

        if (this.estudio.generacion) {
          const [inicio, fin] = this.estudio.generacion.split('-')
          this.generacionInicio = inicio || ''
          this.generacionFin = fin || ''
        }
      }
    },

    async guardarCambios() {
      if (!this.estudio.idEstudioPersonal) {
        console.error('Error: ID del estudio no encontrado')
        return
      }

      this.loading = true
      try {
        const payload = {
          id: this.estudio.idEstudioPersonal,
          fk_idPersonal: this.estudio.fk_idPersonal,
          institucion: this.estudio.institucion,
          generacion: this.generacionInicio + '-' + this.generacionFin,
          observaciones: this.estudio.observaciones,
          fk_idCatEstatusEstudio: this.estudio.fk_idCatEstatusEstudio,
          fk_idCatEstudio: this.estudio.fk_idCatEstudio,
          fk_idComprobanteEstudio: this.estudio.fk_idComprobanteEstudio,
        }

        await this.updateEstudiosPersonal(payload)
        await this.fetchEstudiosByPersonal(this.estudio.fk_idPersonal)
        this.$emit('close')
      } catch (e) {
        console.error('Error al guardar cambios:', e)
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    this.cargarDatosEstudio()
    await this.cargarCatalogos()
  },
}
</script>
